/*
 * @Author: 哎呦先生 392632962@qq.com
 * @Date: 2024-02-20 09:49:36
 * @LastEditors: 哎呦先生 392632962@qq.com
 * @LastEditTime: 2024-03-07 11:50:38
 * @FilePath: \官网\src\view\job\index.jsx
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
import React from 'react';
import { enquireScreen } from 'enquire-js';
import Banner3 from '../../compoment/Banner3';//1
import Feature0 from '../../compoment/Feature0';//功能
import Footer1 from '../../compoment/Footer1';//页脚单独引
import { Footer10DataSource } from '../../data/head.source'//页脚单独引
import {
    jobSource,//1

} from '../../data/news.source';
import '../../assets/less/antMotionStyle.less';
import Job from '../../compoment/Job'
let isMobile;
enquireScreen((b) => {
    isMobile = b;
});
const { location = {} } = typeof window !== 'undefined' ? window : {};
export default class job extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile,
            newsdata: [
                {
                    jobName: '分管产品研发副总经理',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.制定产品研发战略和规划，负责产品研发方向、目标和计划的制定，确保项目研发计划按时完成并达成公司业务目标',
                        '2.负责管理产品研发团队，确保团队按照工作计划高效运转',
                        '3.管理和优化产品研发流程，制定研发流程规范和流程优化建议',
                        '4.负责研发成本节约和资源管理，确保项目开发成本处于可控范围',
                        '5.参与市场推广方案制定及执行，从研发的角度出发为市场推广提供技术支持和准备，确保产品推广顺利进行',



                    ],
                    jobask: [
                        '1.统招本科以上学历，电气、计算机、软件工程、自动化或相关专业，统招硕士研究生以上优先，新能源·电力/热力/燃气/水利背景优先',
                        '2.10年以上相关行业产品研发管理经验，具有较强的技术背景和实践经验',
                        '3.具备良好的团队管理技巧和沟通协调能力，能够有效引导和管理研发团队，优化团队配合效率',
                        '4.精通研发规划、流程管理、研发成本控制等知识',
                        '5.具备市场分析和产品开发的能力，对市场变化有较敏锐的洞察力，能够有效把握市场变化趋势',
                        '6.具备强烈的责任感、进取心和创新意识，能够主动解决问题并具有高度的工作积极性',



                    ],

                },
                {
                    jobName: '产品经理（功率预测）',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.研究分析预测产品相关的市场发展、用户需求、核心技术以及行业标准',
                        '2.对接客户，分析客户需求，根据公司产品为客户提供针对性的解决方案',
                        '3.负责预测产品业务应用系统需求分析和系统设计',
                        '4.负责预测产品业务应用开发过程项目管理。',
                        '5.配合销售进行方案讲解、产品演示，展现公司产品及方案优势',
                        '6.发现产品现状与客户诉求的差异空间，推动产品功能优化及解决方案迭代'


                    ],
                    jobask: [
                        '1.全日制统招本科及以上学历，电气、计算机、软件工程、新能源或相关专业',
                        '2.5年以上电力行业信息化项目解决方案或交付经验',
                        '3.熟悉电力综合自动化、功率预测、AGC/AVC等相关系统',
                        '4.具有一定的文档撰写能力和方案设计能力，熟练使用PPT制作汇报方案',
                        '5.具有良好的沟通协调能力，能够主动协调各方资源策划解决方案',
                        '6.能适应频繁短时间出差',



                    ],

                },
                {
                    jobName: '产品经理（控制调频）',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.研究分析新能源场站有功无功自动控制项目、一次调频产品相关的市场发展、用户需求、核心技术以及行业标准',
                        '2.对接客户，分析客户需求，根据公司产品为客户提供针对性的解决方案',
                        '3.负责控制调频产品业务应用系统需求分析和系统设计',
                        '4.负责控制、调频产品业务应用开发过程项目管理',
                        '5.负责控制、调频售前工作，具有一定的市场推广能力，包括但不限于技术方案编制、售前交流等',
                        '6.协助研发推进新产品、新技术标准化，并进行产品的客户培训'


                    ],
                    jobask: [
                        '1. 全日制统招本科学历，电气工程及其自动化、计算机、通信等相关专业',
                        '2.熟悉新能源场站综合自动化网络机构，能够分析常见规约例如：modbus、IEC104等通信协议',
                        '3.熟悉新能源电站的二次接线设计，并能进行相应施工图纸的修改',
                        '4.学习能力强，沟通能力强，吃苦耐劳，具备团队合作精神',
                        '5.能适应频繁短时间出差',
                        '6.条件优秀者可放宽条件',



                    ],

                },

                {
                    jobName: '产品经理（电网）',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.负责电网业务产品市场推广和技术交流，规划公司产品研发设计方向',
                        '2.负责收集、汇总电网项目客户需求，进行业务需求分析，形成标准化设计文档及需求规格说明书',
                        '3.组织开展产品概要设计，完成原型设计',
                        '4.协同研发部等相关部门推动产品研发，并对产品质量进行把关',
                        '5.负责电网产品的运营优化和版本迭代规划工作',



                    ],
                    jobask: [
                        '1.5年以上工作经验，本科及以上学历，计算机、软件工程、电气工程等相关专业',
                        '2.熟悉电力调度、新能源管理相关业务，具有一定的电力调度运行技术知识',
                        '3.熟悉软件研发项目需求分析、功能设计、研发、实施、交付等各个环节，拥有良好的组织协调能力',
                        '4.有丰富的软件系统产品管理或功能设计经验，熟练使用Axure等原型设计软件',
                        '5.有产品经理经验、软件研发经验、团队管理经验、电力相关背景者优先'



                    ],

                },

                {
                    jobName: '产品经理（电力交易）',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.负责公司电力交易产品业务规划、路标规划、产品设计、产品开发管理等工作',
                        '2.负责国内各省电力市场的政策研究和市场调研分析',
                        '3.基于各省电力市场最新交易规则进行产品需求设计完善、交易策略研究',
                        '4.挖掘地区客户需求，制定产品定制化解决方案',
                        '5.负责部分省份的电力交易市场推广、技术支持、售前交流等工作,降低开发成本',



                    ],
                    jobask: [
                        '1.年以上工作经验，本科及以上学历，电气、计算机、软件工程等相关专业',
                        '2.熟悉电力市场的基本原理，了解国内外电力市场现状，对电力市场有基础认知',
                        '3.具备熟练的产品定义、分析、设计等产品经理技能',
                        '4.有能源电力行业工作背景者优先',
                        '5.有面向发电企业、售电公司等电力交易相关项目工作经验者优先',



                    ],

                },

                {
                    jobName: '产品经理（储能）',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.负责收集储能行业内的相关政策、储能产品及解决方案的需求规格、客户及友商等相关市场信息',
                        '2.根据公司战略规划、市场政策和客户的需求，完成市场需求调研任务，规划储能业务方向的产品规格与解决方案，完成储能场景设计',
                        '3.负责储能业务方案的制定，参与项目的技术论证或审核，在技术层面提出改进的方向和意见',
                        '4.研判国内外电化学领域储能电站EMS技术和应用发展现状和趋势，构建适应不同应用场景产品技术和应用方案',
                        '5.对储能系统业务的销售策略进行规划、执行和控制，为最终用户和渠道合作伙伴及时提供有竞争力的产品和解决方案建议书',


                    ],
                    jobask: [
                        '1.全日制统招本科及以上学历，电气、电力、自动化、新能源等相关专业',
                        '2.2年以上储能行业产品经理相关工作经验，具有储能产品规划、开发和管理经验',
                        '3.具备独立组织实施储能产品及解决方案的市场推广能力和经验',
                        '4.拥有储能行业、锂电池行业，电网企业、新能源相关咨询设计机构工作经验优先',
                        '5.熟悉储能的相关国家政策、行业标准和技术规范，熟悉储能技术方向',
                        '6.有敏锐的市场意识、应变能力，学习能力强；逻辑性强和良好的语言表达能力'


                    ],

                },
                {
                    jobName: '产品经理（虚拟电厂）',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.熟悉虚拟电厂、需求响应、低碳智慧园区、了解电力市场、综合能源产品，理解业务/产品背景与需求',
                        '2.根据各省虚拟电厂、市场化需求响应、用户侧电力调峰辅助服务等政策或交易规则，对虚拟电厂的组织方式、调控方式、资源组合等进行规划和设计',
                        '3.梳理业务需求，分析提炼，输出业务规格说明书和产品原型设计；根据项目要求，高质量交付产品设计，推动产品的持续改进',
                        '4.为营销人员、市场人员提供与虚拟电厂相关的技术支持，包括但不限于技术支撑、方案支撑、营销支撑等',
                        '5.完成公司、上级交付或授权的其他工作',


                    ],
                    jobask: [
                        '1.本科及以上学历，电力、电气、自动化、新能源等专业优先考虑',
                        '2.3年以上相关工作经验，熟悉集团企业、园区综合能源、电力市场等业务和解决方案(熟悉虚拟电厂业务流程者有限考虑)，具有一定的信息化知识',
                        '3.市场敏感度高，擅于从市场及客户业务研究中捕捉商机，推动商机的达成',
                        '4.具备良好的方案撰写能力、演讲能力，能够面向客户讲解汇报方案，并能以实例培训他人',
                        '5.在日常与客户的业务交流中，通过专业能力维系和稳定关键客户关系，提升客户忠诚度',



                    ],

                },
                {
                    jobName: '电力交易数据分析师',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.负责公司电力交易市场发布数据收集整理分析等工作',
                        '2.基于各省电力市场最新交易规则进行大数据分析和算法验证分析',
                        '3.负责部分省份的电力交易产品的收益分析、发布和答疑的等支持工作',

                    ],
                    jobask: [
                        '1.有2年电力营销、电力交易以上相关工作经验（数据/业务分析、决策支持、数据挖掘）',
                        '2. 数学、统计、经济学等相关专业本科及以上学历',
                        '3.对数据驱动业务有深入理解，对数据与业务方面有足够的敏感性，有较强的逻辑分析能力和独立思考能力',
                        '4.具备良好的沟通能力、团队合作精神及抗压能力，能独立高效完成复杂分析项目',
                        '5. 有一定的大数据处理能力，能熟练运用ORACLE/MY SQL/HIVE等获取分析所需数据',
                        '6.有一年以上使用R或者python等脚本语言数据处理经验',

                    ],

                },
                {
                    jobName: '算法工程师',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.研究新能源功率预测、发电量预测、负荷预测建模方法，新能源电力市场交易量价申报决策',
                        '2.基于风电场和光伏电场运行数据，进行挖掘、融合和数据分析，发挥数据的价值',
                        '3.机器学习和深度学习算法开发和测试、系统算法优化',
                        '4.设计电力交易算法框架、不同模型的目标和交易的测试流程',
                        '5.提供新能源功率预测相关科技项目技术支撑',
                        '6.提供省调主站功率预测、区域预测等技术支撑'

                    ],
                    jobask: [
                        '1.本科及以上学历，数据科学与大数据技术、数学等相关专业优先，有电力系统功率预测项目算法开发和数据挖掘经验优先',
                        '2.熟悉mysql\SQLServer中的某一种数据库，熟练使用sql语言',
                        '3.具备扎实的编程能力，精通Python编程以及算法常用模块如numpy、pandas、sklearn、matplotlib、xgboost、TensorFlow、Keras等等',
                        '4.了解并使用用过 KNN，GBDT，SVM，Xgboost，Lgbm 等机器学习模型，使用过 CNN，LSTM，ResNet 等神经网络模型',
                        '5.能驾驭面向海量数据的大规模机器学习技术，熟悉至少一种深度学习开源框架并有较深入理解，如Caffe、TensorFlow等，并掌握相关实现及优化方案',
                        '6.目标导向，有较强的自学能力、逻辑思维能力、独立分析问题解决问题的能力和良好的沟通表达能力，适应高强度工作压力'


                    ],

                },

                {
                    jobName: '数据服务工程师',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.负责新能源电站的模型训练、精度运维、数据分析',
                        '2.负责编写精度分析报告和精度提升方案并根据需要编写回复函',
                        '3.负责跟客户进行精度方面的技术交流',
                        '4.负责跟进系能源场站的收资',
                        '5.完成上级领导安排的其他工作',


                    ],
                    jobask: [
                        '1.本科及以上学历，计算机、数学、电力、自动化等相关专业',
                        '2.对算法和气象在行业需求中的应用有较深入的认识',
                        '3.较强的分析、解决问题能力，思路清晰，考虑问题细致',
                        '4.较强的沟通协调能力，较强的服务意识',
                        '5.为人正直、责任心强、作风严谨、工作仔细认真',



                    ],

                },
                {
                    jobName: '气象工程师 ',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.负责气象算法研究、气象大数据多源融合建模，负责短临、中期和长期气象预报模型构建',
                        '2.负责数值预报系统的维护与优化，数值天气预报最新技术的调研与开发应用',
                        '3.负责数值预报系的开发，中尺度数值预报技术的开发与优化',
                        '4.负责新能源、电网等项目中气象方向的技术研究',
                        '5.协助气象服务系统的开发，应用',


                    ],
                    jobask: [
                        '1.大气科学、气象学、空气动力学等相关专业硕士研究生及以上学历，具有良好的气象知识基础，有数值气象预报相关工作经验者。1年以上气象技术开发经验者，优先录用',
                        '2.熟悉WRF等中尺度模式、熟悉数据同化与集合预报等技术',
                        '3.熟悉Linux系统，熟练使用shell/python/ncl/fortran等语言',
                        '4.具有团队合作精神和独立的研究能力，有学术科研追求和工作责任心',
                        '5.能适应短期出差，抗压能力强',



                    ],

                },

                {
                    jobName: '高级JAVA研发工程师',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.根据公司内部各项目研发需求及工作安排，参与项目应用研发',
                        '2.负责带领、指导低级别技术人员的开发工作',
                        '3.负责相关技术文档的编制及审核工作',
                        '5.协助高层级研发人员，开展互联网、传统应用最新技术的跟踪调研、及时总结专业知识技术发展的最新趋势和成果',


                    ],
                    jobask: [
                        '1.熟悉JavaEE体系结构，精通Java语言开发，有至少三年以上JavaEE实际开发和应用经验',
                        '2.精通SpringMVC、Spring、Mybatis等框架，了解其设计原理并具有实际应用开发经验',
                        '3.熟悉AJAX、XML，熟练使用 XmlHttpRequest/iframe 等数据交互编程',
                        '4.熟悉主流的Oracle、MySql、国产达梦、瀚高等数据库系统，以及Redis、Memcached等分布式缓存技术的安装、配置及开发',
                        '5.熟悉Tomcat、Nginx、Jboss等开源软件的安装、集群配置，能够承载大规模高并发的访问请求',
                        '6.熟练使用Linux操作系统命令',
                    ],

                },
                {
                    jobName: '高级C++研发工程师',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.参与编制软件产品的概要设计说明书和详细设计说明书',
                        '2.从事通讯接口类和控制类研发工作',
                        '3.执行项目模块的编码，实施单元测试，保证软件的正常运行',
                        '4.协助测试人员完成测试并对模块质量负责',
                        '5.维护和升级现有的产品和项目，解决试用中发生的问题',
                        '6.从事通讯平台相关的技术支持',
                        '7.负责集成项目的技术指导及技术咨询',


                    ],
                    jobask: [
                        '1.对电网运行安全稳定控制与新能源并网控制等领域较为熟悉至少全程参加过一次相关科研项目或开发项目',
                        '2.较强的系统需求分析、架构设计、文档编写能力；精通C++跨平台编程,熟悉Linux操作系统。',
                        '3.精通自动控制原理,有2年以上逻辑控制算法开发经验',
                        '4.至少熟悉以下一种或多种电力行业规约的开发:IEC-101、103、104、CDT、modbus tcp等。精通TCP/IP、多线程、同步、SOCKET、STL等开发',
                        '5.熟练使用自动化组态软件；能够编写、调试组态脚本程序；为项目售前提供技术咨询和现场调研',
                        '6.熟悉SOCKET通讯、TCP/UDP等网络协议；熟悉C/C++ , 熟练使用VC++进行软件开发'


                    ],

                },
                {
                    jobName: '前端研发工程师',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1. 负责PC端/移动端Web前端技术的构建和实现',
                        '2.负责整体页面结构及样式层结构的设计及优化',
                        '3.根据产品原型和效果图，独立完成前端开发工作',
                        '4.对产品交互和页面布局提出合理化建议',
                        '5.负责协助编制、优化前端开发相关技术规范',


                    ],
                    jobask: [
                        '1.精通 HTML、CSS 进行页面构建和布局,熟悉W3C标准，了解各主流浏览器特性以及不同浏览器之间的差异',
                        '2.熟悉前端自动化构建工具（如Webpack、Gulp等），能够配置和优化构建流程，提高开发效率',
                        '3.熟悉recat使用，并有实际react开发经验',
                        '4.深入熟悉 Vue.js 2 和 Vue.js 3 全家桶，具备在实际项目中进行组件化开发的经验',
                        '5.具备 Chrome 应用开发经验，了解 Chrome 插件的开发流程，能够使用 Chrome 开发者工具进行调试和性能优化',
                        '6.深入理解浏览器渲染原理，能够通过性能优化手段提高页面加载速度和性能'


                    ],

                },
                {
                    jobName: '测试工程师',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.参与编制、优化产品（预研）开发项目的测试流程规范',
                        '2.参与产品（预研）开发项目需求分析的编写',
                        '3.负责制定产品（预研）开发项目的测试计划、测试策略',
                        '4.负责编写产品（预研）开发项目的测试用例',
                        "5.负责组织搭建产品（预研）开发项目的测试环境",
                        "6.负责（参与）管理产品（预研）开发项目的测试环境",
                        "7.按测试计划执行项目测试工作，保证测试的质量、进度达标",

                    ],
                    jobask: [
                        '1.具备编制测试计划、制定测试策略、编制测试报告的能力',
                        '2.具备测试执行经验，具备搭建测试环境、编制测试用例、缺陷跟踪管理的能力',
                        '3.熟悉至少一种主流数据库，包括Oracle， MySQL等',
                        '4.了解至少一种主流编程语言，包括C++、Java、python#等',
                        '5.熟悉至少一种主流自动化测试工具，包括不限于JMeter、Loadrunner、QTP等',
                        '6.熟悉至少一种主流测试管理工具，包括QC，Jira等'

                    ],

                },




                {
                    jobName: '技术支持中心总监',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.根据公司的经营战略规划，全面主持技术支持中心工作，组织建立并完善部门管理制度、规范及工作流程',
                        '2.负责制定部门经营计划，并监督、控制经营计划执行情况',
                        '3.负责监督、指导实施项目、运维项目的进度、质量、成本控制等工作，并根据实际情况进行资源调配，以提高客户对项目的满意度',
                        '4.负责各区域实施运维团队管理建设，保障公司项目实施与运维',
                        '5.负责实施运维标准化和技术规范，并及时更新调整',
                        '6.负责解决项目实施运维中的重大疑难问题处理',


                    ],
                    jobask: [
                        '1.本科及以上学历，计算机技术、电力、通信工程等相关专业',
                        '2.5年以上同等岗位工作经验，10年以上系统集成相关工作经验',
                        '3.有强烈的责任心，敬业度，优秀的团队管理能力，能够带领团队在压力下完成目标',
                        '4.具有较强的客户沟通、协调与服务能力',
                        '5.具有较强的研究分析能力、文案功底',
                        '6.能适应不定期出差'


                    ],

                },
                {
                    jobName: '项目经理',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '北京海淀',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.负责执行公司/部门管理要求与考核规范',
                        '2.负责项目组（区域）管理工作',
                        '3.负责项目从立项到验收过程中的实施运维的管理，根据项目工作目标，制定项目执行计划，并监督、控制计划执行情况',
                        '4.负责监督、执行各类项目的进度、质量、服务、成本控制等工作，以提高客户对项目的满意度',
                        '5.负责质保期内与服务期内项目日常运维的管理',
                        '6.从公司、部门、项目组，到产品、调度区域、项目角度做好本区域项目全生命周期管理，对应产品全生命中涉及各项问题提出各项意见',


                    ],
                    jobask: [
                        '1.本科及以上学历，计算机技术、电力自动化、通信工程等相关专业',
                        '2.5年以上同等岗位工作经验，10年以上系统集成相关工作经验',
                        '3.有强烈的责任心，敬业度，优秀的团队管理能力，能够带领团队在压力下完成目标',
                        '4.具有较强的客户沟通、协调与服务能力',
                        '5.具有较强的研究分析能力、文案功底',
                        '6.能适应不定期出差'


                    ],

                },

                {
                    jobName: '实施运维工程师',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '不限',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.负责完成工程项目安装、调试、运维工作',
                        '2.实施项目系统的远程调试',
                        '3.网络设备调试',
                        '4.负责项目现场培训工作',
                        '5.执行项目的现场和远程维护工作'
                    ],
                    jobask: [
                        '1.全日制专科及以上学历，计算机技术、电力、通信工程等相关专业',
                        '2.熟练使用Linux操作系统，熟悉主流数据库（MySQL、Oracle等），能完成增删改查等操作',
                        '3.表达清晰，有良好的技术讲解能力；吃苦耐劳、纪律性及团队合作意识强',
                        '4.具备一定的现场组织协调能力',
                        '5.能长期在工作地点省份出差',
                        '6.从事过新能源及电力行业者优先',

                    ],

                },



                {
                    jobName: '销售总监',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '不限',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.组织制定年度营销规划，包含销售目标、策略等',
                        '2.收集市场环境信息、包含竞争情况、客户信息等，并分析市场环境发展趋势',
                        '3.对公司具有战略业务价值的行业管理部门、市场资源实施战略合作式管理',
                        '4.以重复交易为目标，管理客户关系，特别是针对大型、战略客户实施专门服务管理',
                        '5.组织各区域及大客户经理设计销售策略，完成年度销售目标',
                        '6.组织开展合同、投、议标和应收款管理相关工作',

                    ],
                    jobask: [
                        '1.本科及以上学历，市场营销类、管理类、电力等相关专业',
                        '2.具有8年以上电力或高科技行业销售管理工作经验',
                        '3.具有5年以上新能源类产品销售管理经验及行业主管政府公共关系经验',
                        '4.具有敏锐的市场感知、把握市场动态和市场方向的能力',
                        '5.极具开拓精神和创造性解决问题的能力',
                        '6.勇于竞争，勤奋积极，具有超强的心理压力承受能力',

                    ],

                },
                {
                    jobName: '大客户销售经理',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '不限',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.根据公司经营战略与年度销售目标，制定渠道及大客户年度销售目标',
                        '2.负责大型集团、电网及政府客户关系规划、管理（拓展、维护）',
                        '3.负责关键渠道客户关系规划、管理（拓展、维护）',
                        '4.收集渠道及大客户的需求信息，关注大客户的发展趋势和业务走向并及时反馈，保证需求、信息的有效传递',
                        '5.根据产品部对于新品市场的预测及规划,在关键渠道及大客户进行推广',

                    ],
                    jobask: [
                        '1.本科、具有营销或销售管理专业知识，具新能源、电力、信息技术背景者优先',
                        '2.具有5年以上高端客户（政府、集团客户）销售及服务经验',
                        '3.具有能源、高新技术销售及服务经验为佳，或已经拥有至少1个以上大型能源高端客户关系并有成功销售案例',
                        '4.能吃苦耐劳，能适应出差',


                    ],

                },
                {
                    jobName: '销售经理',
                    head: {
                        unit: '东润环能',
                        limit: '不限',
                        city: '不限',
                        date: '2024-02-20',
                        email: 'hr@eeechina.cn',

                    },
                    jobdesc: [
                        '1.根据年度销售目标，制定并执行相应的销售计划与策略,完成所辖区域销售目标',
                        '2.收集所辖区域内的市场环境信息、包含竞争情况、客户信息等，并分析市场环境发展趋势',
                        '3.拓展所辖区域内的客户关系，并筛选目标客户及重点项目',
                        '4.根据项目招标（议标）信息，提出招标（议标）策略建议并组织应标',
                        '5.收回所辖区域内成交项目的应收帐款'

                    ],
                    jobask: [
                        '1.专科及以上学历，新能源、电气相关专业或经济、管理相关专业，具新能源、电力、信息技术背景为佳',
                        '2.具有3年以上电力行业销售经验',
                        '3.或具有3年以上高新技术类产品客户开发与销售服务经验，同时具有本行业1年以上销售团队建议及管理经验者优先',
                        '4.具有较强的计划执行能力、市场判断与决策能力',
                        '5.具有良好的沟通能力、客户服务能力',



                    ],

                },





            ]

        };
        this.pdfPath = '../../assets/pdf/东润环能资讯：东方宇华出售浑源49%股权价款于2023年底前收妥 - 清洁版.pdf';
    }
    componentDidMount () {
        enquireScreen((b) => {
            this.setState({ isMobile: !!b });
        });

    }

    render () {
        const children = [
            <Banner3
                key="news_0"
                dataSource={jobSource}
                isMobile={this.state.isMobile}
                style={{ height: '50vh' }}
            />,
            <Job style={{ marginBottom: '80px', marginLeft: isMobile ? '0%' : '10%', marginRight: isMobile ? '0%' : '10%' }} data={this.state.newsdata} key="job_abc" />,
            <Footer1
                id="Footer1_0"
                key="Footer1_0"
                dataSource={Footer10DataSource}
                isMobile={this.state.isMobile}
            />
        ];
        return (
            <div className="templates-wrapper" ref={(d) => { this.dom = d; }} style={{ backgroundColor: '#F4F5F7' }}>
                {children}
            </div>
        );
    }
}
